import Joi from '@hapi/joi'

export const EODDetailsObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    estateID: Joi.number().required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity cannot have invalid characters`,
        "any.required": `Operation Entity characters`
    }),
    divisionID: Joi.number().required().label("Collection Point").messages({
        "any.invalid": `Collection Point cannot have invalid characters`,
        "any.required": `Collection Point Type characters`
    }),
    fieldID: Joi.number().required().label("Feild Name").messages({
        "any.invalid": `Feild Name cannot have invalid characters`,
        "any.required": `Feild Name Type characters`
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),
    sessionID: Joi.string().label("Session"),
    status: Joi.string().label("Status")

}